module.exports = __webpack_public_path__ + "static/img/rs_js_3.fb47893.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_3.png
// module id = 5gjV
// module chunks = 1